import React, { useEffect, useState } from "react";
import { Modal, Heading, useMediaQuery } from "native-base";
import { COLORS } from "../../utils/colors";
import "./style.css";
import { MOBILE_VIEW_WIDTH } from "../../utils/screens";

const CustomModal = ({
  width = "xl",
  size = "xl",
  isOpen = false,
  onClose = () => {},
  header = "",
  body = "",
  footer = "",
  raiseReq = false,
  top = "150px",
  display = undefined,
  fixedPosition = false,
  fixedTop = 20,
  maxH = "100%",
  ...props
}) => {
  const [MobileWindow] = useMediaQuery({
    maxWidth: MOBILE_VIEW_WIDTH,
  });

  const [scrollPosition, setScrollPosition] = useState(0);
  const [topMargin, setTopMargin] = useState(0);

  useEffect(() => {
    if (fixedPosition) {
      const handleScroll = () => {
        setScrollPosition(window.scrollY);
      };
      window.addEventListener("scroll", handleScroll);
      if (isOpen) {
        document.body.classList.add("modal-open");
      } else {
        document.body.classList.remove("modal-open");
      }
      setTopMargin(window.scrollY + fixedTop);
      return () => {
        document.body.classList.remove("modal-open");
        window.removeEventListener("scroll", handleScroll);
      };
    }
  }, [isOpen, fixedPosition]);

  return (
    // <div className="r-right-zchlnj r-left-1d2f490">
    <Modal
      size={MobileWindow ? "100%" : size}
      isOpen={isOpen}
      onClose={onClose}
      alignItems={MobileWindow ? "none" : "center"}
      zIndex=""
    >
      <Modal.Content
        display={display}
        marginBottom="auto"
        marginTop={fixedPosition ? topMargin : top}
        height={props.height}
        maxH={MobileWindow ? undefined : maxH}
        p={MobileWindow ? 0 : 15}
        bg={COLORS.WHITE_COLOR}
        maxWidth={width}
        borderRadius={"8px"}
        style={MobileWindow && { bottom: 0, left: 0, right: 0 }}
      >
        <Modal.CloseButton />
        {header && (
          <Modal.Header
            bg={COLORS.WHITE_COLOR}
            borderBottomWidth={0}
            width={MobileWindow && "95%"}
          >
            <Heading size="md" fontSize={"24px"}>
              {header}
            </Heading>
          </Modal.Header>
        )}
        {body && <Modal.Body bg={COLORS.WHITE_COLOR}>{body}</Modal.Body>}
        {footer && (
          <Modal.Footer
            bg={COLORS.WHITE_COLOR}
            borderTopWidth={0}
            justifyContent={props.justifyContent}
          >
            {footer}
          </Modal.Footer>
        )}
      </Modal.Content>
    </Modal>
    // </div>
  );
};

export default CustomModal;
